import React, { useState, useEffect } from "react";
import DynamicMeal from "./DynamicMeal";
import { Tabs, Tab } from "react-bootstrap";
import BottomTabNav from "../../../customs/BottomTabNav";
import { useDispatch, useSelector } from "react-redux";
import { updateMeals } from "../../../../../actions/restaurantAction";

export default function Meals(props) {
    const dispatch = useDispatch()
    const restaurant = useSelector(state => state.restaurant)

    const [key, setKey] = useState("Monday");
    const [meals, setMeals] = useState([{ category: "Lunch", items: [] }, { category: "Dinner", items: [] }]);
    const [id, setId] = useState("")
    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        let componentMount = true
        if (componentMount) {
            if (typeof restaurant === 'object' && Object.keys(restaurant).length !== 0) {
                setId(restaurant.restaurant_id)
                setDisabled(false)
            } else {
                setDisabled(true)
            }
        }
        return () => {
            componentMount = false
        }
    }, [restaurant])

    const addMeal = async (slot, meal) => {
        let thisMeals = [...meals]
        thisMeals.find((item) => item.category === slot).items.push(meal)
        setMeals(thisMeals)
        const response = await dispatch(updateMeals(id, meals))
    };

    return (
        <fieldset>
            <Tabs
                className="tabs-container mt-1"
                activeKey={key}
                onSelect={(k) => setKey(k)}
            >
                <Tab eventKey="Monday" title="Monday">
                    <DynamicMeal index={1} addMeal={addMeal} day="Monday" disabled={disabled} />
                </Tab>
                <Tab eventKey="Tuesday" title="Tuesday">
                    <DynamicMeal index={2} addMeal={addMeal} day="Tuesday" disabled={disabled} />
                </Tab>
                <Tab eventKey="Wednesday" title="Wednesday">
                    <DynamicMeal index={3} addMeal={addMeal} day="Wednesday" disabled={disabled} />
                </Tab>
                <Tab eventKey="Thursday" title="Thursday">
                    <DynamicMeal index={4} addMeal={addMeal} day="Thursday" disabled={disabled} />
                </Tab>
                <Tab eventKey="Friday" title="Friday">
                    <DynamicMeal index={5} addMeal={addMeal} day="Friday" disabled={disabled} />
                </Tab>
                <Tab eventKey="Saturday" title="Saturday">
                    <DynamicMeal index={6} addMeal={addMeal} day="Saturday" disabled={disabled} />
                </Tab>
                <Tab eventKey="Sunday" title="Sunday">
                    <DynamicMeal index={7} addMeal={addMeal} day="Sunday" disabled={disabled} />
                </Tab>
            </Tabs>

            <BottomTabNav currentStep={3} props={props} />
        </fieldset>
    );
}
